import React from 'react'

import type {
  LotStoryPrivateWritePreflightView,
  TranslateFn
} from './lotStoryLibraryTypes'

type LotStoryPrivateWritePreflightCardProps = {
  t: TranslateFn
  preflight: LotStoryPrivateWritePreflightView
  testIdPrefix: string
}

const getTestId = (prefix: string, suffix?: string) => suffix ? `${prefix}-${suffix}` : prefix

export default function LotStoryPrivateWritePreflightCard({
  t,
  preflight,
  testIdPrefix
}: Readonly<LotStoryPrivateWritePreflightCardProps>) {
  const isLoading = preflight.status === 'loading' || preflight.status === 'idle'
  const statusMessage = preflight.status === 'allowed'
    ? t('lots.story.preflight.status.allowed')
    : preflight.status === 'readonly'
      ? t('lots.story.draft.readonly')
      : t('lots.story.preflight.status.denied')

  return (
    <div
      data-testid={getTestId(testIdPrefix)}
      style={{
        border: '1px solid #d1fae5',
        borderRadius: 10,
        backgroundColor: '#ecfdf5',
        padding: 12,
        display: 'grid',
        gap: 8
      }}
    >
      <div style={{ display: 'grid', gap: 4 }}>
        <strong style={{ fontSize: 12, color: '#065f46' }}>{t('lots.story.preflight.title')}</strong>
        <div style={{ fontSize: 13, color: '#065f46' }}>{t('lots.story.preflight.subtitle')}</div>
      </div>

      {isLoading ? (
        <div data-testid={getTestId(testIdPrefix, 'status')} style={{ fontSize: 13, color: '#065f46', fontWeight: 700 }}>
          {t('lots.story.preflight.loading')}
        </div>
      ) : preflight.errorMessage ? (
        <div data-testid={getTestId(testIdPrefix, 'status')} style={{ fontSize: 13, color: '#b91c1c', fontWeight: 700 }}>
          {preflight.errorMessage}
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 6, fontSize: 13, color: '#065f46' }}>
          <div data-testid={getTestId(testIdPrefix, 'identity')}>
            <strong>{t('lots.story.preflight.identity')}:</strong> {preflight.identityLabel || t('lots.story.preflight.none')}
          </div>
          <div data-testid={getTestId(testIdPrefix, 'role')}>
            <strong>{t('lots.story.preflight.tenantRole')}:</strong> {preflight.roleLabel || t('lots.story.preflight.none')}
          </div>
          <div data-testid={getTestId(testIdPrefix, 'groups')}>
            <strong>{t('lots.story.preflight.activeGroups')}:</strong> {preflight.activeGroupCount}
          </div>
          <div data-testid={getTestId(testIdPrefix, 'partners')}>
            <strong>{t('lots.story.preflight.partnerOrganizations')}:</strong> {preflight.partnerOrganizationsLabel || t('lots.story.preflight.none')}
          </div>
          <div
            data-testid={getTestId(testIdPrefix, 'status')}
            style={{
              color: preflight.status === 'allowed' ? '#166534' : '#b91c1c',
              fontWeight: 700
            }}
          >
            {statusMessage}
          </div>
        </div>
      )}
    </div>
  )
}